import { createContext, useContext, useMemo, ReactNode } from 'react';
import { TruktTmsApi } from '@trukt/tms-api/TruktTmsApi';
import { TrimbleMapsSingleSearchApi } from '@trukt/portal-utils/TrimbleMapsSingleSearchApi';

export interface ApiProviderValue {
  truktApi: TruktTmsApi;
  trimbleApi: TrimbleMapsSingleSearchApi | null;
}

export interface ApiProviderProps extends ApiProviderValue {
  children: ReactNode;
}

const ApiContext = createContext<ApiProviderValue | undefined>(undefined);

export const ApiProvider = ({ children, trimbleApi, truktApi }: ApiProviderProps) => {
  const value = useMemo(() => ({ truktApi, trimbleApi }), [trimbleApi, truktApi]);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useApiContext = () => {
  const context = useContext(ApiContext);

  if (!context) throw new Error('useApiContext must be used within a ApiProvider');

  return context;
};
